<script>
import axios from '@/utils/axios';

export default {
  data() {
    return {
      announcement: null,
      loading: false,
    };
  },
  methods: {
    async open(id) {
      this.announcement = null;
      this.loading = true;
      try {
        const res = await axios.get(`/hrms/announcements/my/${id}`);
        this.announcement = res.data.data;
      } catch (error) {
        this.$swalToast(error.message, 'error');
      } finally {
        this.loading = false;
      }
    },

    typeClass(type) {
      const map = {
        general: 'mv-tag mv-general',
        urgent: 'mv-tag mv-urgent',
        event: 'mv-tag mv-event',
        policy: 'mv-tag mv-policy',
      };
      return map[type] || 'mv-tag mv-general';
    },
  },
};
</script>

<template>
  <div class="modal fade" id="hrm_announcement_view_modal">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Announcement</h4>
          <button type="button" class="btn-close custom-btn-close" data-bs-dismiss="modal" aria-label="Close">
            <i class="ti ti-x"></i>
          </button>
        </div>

        <div class="modal-body">
          <div v-if="loading" class="text-center py-4 text-muted">
            <div class="spinner-border spinner-border-sm text-primary mb-2"></div>
            <div>Loading...</div>
          </div>

          <template v-else-if="announcement">
            <div class="d-flex align-items-center gap-2 mb-2">
              <span :class="typeClass(announcement.type)">{{ announcement.type }}</span>
              <span style="font-size:11px; color:#94a3b8;">
                <i class="ti ti-calendar-event me-1"></i>{{ $formatDate(announcement.published_at) }}
              </span>
            </div>
            <h4 class="mb-3" style="font-size:17px; font-weight:700; color:#0f172a;">{{ announcement.title }}</h4>
            <p style="font-size:13.5px; color:#475569; line-height:1.7; white-space:pre-line;">{{ announcement.content }}</p>

            <div v-if="announcement.expires_at" class="mv-expiry mt-3">
              <i class="ti ti-clock me-1"></i>Valid until {{ $formatDate(announcement.expires_at) }}
            </div>
          </template>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-light" data-bs-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.mv-tag {
  display: inline-block; font-size: 10.5px; font-weight: 600;
  padding: 3px 10px; border-radius: 20px; text-transform: capitalize;
}
.mv-general { background: #eef2ff; color: #4f46e5; }
.mv-urgent { background: #fee2e2; color: #dc2626; }
.mv-event { background: #fef3c7; color: #b45309; }
.mv-policy { background: #e0f2fe; color: #0369a1; }

.mv-expiry {
  font-size: 11.5px; color: #92722a;
  background: #fffbeb; border: 1px solid #fde68a;
  border-radius: 8px; padding: 8px 12px; display: inline-block;
}
</style>